
<template>
  <div class="box" v-loading="loading">
    <p class="login_title_sm">{{$t('m.change_mobile')}}</p>
    <div class="login_info">
      <div class="form_item">
        <p>{{$t('m.old_mobile')}}</p>
        <div class="form_inputbox">
          <div class="seledArea" @click.stop="showOldShowCountryFun">
            <img class="flag_icon" :src="selCountryOld.logo">
            <span class="fc-pad-lr-min">+{{selCountryOld.countryNum}}</span>
            <img class="select_icon" :src="(oldShowCountry && $store.state.isShowSelArea)
            ?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
          </div>
          <input class="login_input" type="text" v-model.trim="oldMobile" oninput="value=value.replace(/\D/g,'')" 
          :placeholder="$t('m.user_enter_bind_phone')" minlength="6" />
          <div class="selarea_box"  v-if="oldShowCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionOldFun"/>
          </div>
        </div>
      </div>
      <div class="form_item">
        <p>{{$t('m.vericode')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="text" v-model.trim="oldCode" oninput="value=value.replace(/\D/g,'')" :placeholder="$t('m.input_vericode')" maxlength="6" />
          <div class="getcode">
            <send-code :areaCode="selCountryOld.countryNum" :mobile="oldMobile" :scene="1"></send-code>
          </div>
        </div>
      </div>
      <div class="form_item">
        <p>{{$t('m.new_mobile')}}</p>
        <div class="form_inputbox">
          <div class="seledArea" @click.stop="showNewShowCountryFun">
            <img class="flag_icon" :src="selCountryNew.logo">
            <span class="fc-pad-lr-min">+{{selCountryNew.countryNum}}</span>
            <img class="select_icon" :src="(newShowCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
          </div>
          <input class="login_input" type="text" v-model.trim="newMobile" oninput="value=value.replace(/\D/g,'')" :placeholder="$t('m.user_enter_bind_phone')"  minlength="6"/>
          <div class="selarea_box"  v-if="newShowCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionNewFun"/>
          </div>
        </div>
      </div>
      <div class="form_item">
        <p>{{$t('m.vericode')}}</p>
        <div class="form_inputbox">
          <input class="login_input smscode_input" type="text" v-model.trim="newCode" oninput="value=value.replace(/\D/g,'')" :placeholder="$t('m.input_vericode')" maxlength="6" />
          <div class="getcode">
            <send-code :areaCode="selCountryNew.countryNum" :mobile="newMobile" :scene="1"></send-code>
          </div>
        </div>
      </div>
      <div class="fc-flex-center">
        <div class="login_btn" @click="goLogin">{{$t('m.submit')}}</div>
      </div>
      <p class="fc-text-center fc-color-gray-light fc-mar-t-min fc-pointer changetxt" @click="changephone">{{$t('m.return')}}</p>
    </div>
  </div>
</template>
<script>
import { changeMobile } from '@/api/login/login';
import { getCountryMsg } from '@/api/common';
import sendcode from "@/components/sendcode";
import { isMobileValid,isSmscode } from '@/utils/coding-utils';
import SelArea from '@/components/SelArea';
export default {
  components: {
    "send-code": sendcode,
    "sel-area":SelArea,
  },
  props:{
    agreeXieyi: {
      type: Boolean,
      default () {
        return false;
      }
    },
  },
  data() {
    return {
      loading:false,
      oldMobile: "",
      oldCode: "",
      newMobile:"",
      newCode:"",
      oldShowCountry:false,
      newShowCountry:false,
      countryArr:[],
      selCountryOld:{},
      selCountryNew:{},
    };
  },
  mounted() {
    this.getCountryMsgFun();
  },
  methods: {
    // 
    showOldShowCountryFun(){
      this.newShowCountry = false;
      if(this.oldShowCountry && this.$store.state.isShowSelArea){
        this.oldShowCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.oldShowCountry = true;
      }
    },
    showNewShowCountryFun(){
      this.oldShowCountry = false;
      if(this.newShowCountry && this.$store.state.isShowSelArea){
        this.newShowCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.newShowCountry = true;
      }
    },
    //获取默认区号
    getCountryMsgFun(){
      getCountryMsg().then(({data}) =>{
        this.selCountryOld=data.result;
        this.selCountryNew=data.result;
      })
    },

    countryOptionOldFun(val){
      this.selCountryOld = val;
      this.oldShowCountry = false;
    },

    countryOptionNewFun(val){
      this.selCountryNew = val;
      this.newShowCountry = false;
    },
    changephone(){
        this.$emit("changephone",1)
    },
    goLogin(){
      if(!this.agreeXieyi){
        this.$message.error(this.$t('m.agree_agreement'));
        return false;
      }
      if (!isMobileValid(this.oldMobile)) {
        this.$message.error(this.$t('m.check_phone_istrue'));
        return false;
      }
      if(!isSmscode(this.oldCode)){
        this.$message.error(this.$t('m.vericode_error'));
        return false;
      }
      if (!isMobileValid(this.newMobile)) {
        this.$message.error(this.$t('m.check_phone_istrue'));
        return false;
      }
      // if(this.oldMobile==this.newMobile){
      //   this.$message.error('新旧手机号不能输入一致');
      //   return false;
      // }
      if(!isSmscode(this.newCode)){
        this.$message.error(this.$t('m.vericode_error'));
        return false;
      }
       /* //新手机区号
      private String newAreaCode;

      //旧手机区号
      private String oldAreaCode; */
      this.loading=true;
      changeMobile({
        oldMobile:this.oldMobile,
        oldCode:this.oldCode,
        oldAreaCode:this.selCountryOld.countryNum,
        newMobile:this.newMobile,
        newCode:this.newCode,
        areaCode:this.areaCode,
        newAreaCode:this.selCountryNew.countryNum,
        lang:this.$i18n.locale
      })
      .then(({data}) => {
        this.loading=false;
        this.$store.commit('setUser', data.data);
       if(data.data.status===3){
          //已入驻
          this.$router.push({
            path: '/guild/my-guild-detail'
          });
        }else{
          //0未申请入驻 1入驻申请未通过
          this.$router.push({
            name: 'apply-index',
            params:{
              userStatus:data.data.status,
              stepActive:data.data.status==1?2:0
            }
          });
        }
      }).catch(error => {
        this.loading=false;
        //this.$message.error('登录失败,稍后重试');
      });
    },
  },
};
</script>
<style lang="scss" scoped>

input::-ms-input-placeholder {
	font-size: .18rem;
	color: #999;
}
input::-webkit-input-placeholder {
	font-size: .18rem;
	color: #999;
}
.box{font-size: .14rem;}
input {
  outline: none;
}
.box {
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
}
.login {
  &_title {
    font-size: .36rem;
    text-align: center;
    padding:.67rem 0 .48rem;
    &_sm {
      font-size: .3rem;
      margin-top: .5rem;
    }
  }
  &_info {
    .form_item {
      margin-top: .2rem;
      position: relative;
      p{
        font-size: .18rem;
      }
    }
    .login_input {
      width: 100%;
      height: .54rem;
      font-size: .18rem;
      border: none;
      padding: .1rem 0;
      border-bottom: 1px solid #f3f3f3;
      box-sizing: border-box;
      background-color: transparent;
      color: #333;
    }
    .getcode{
        color: #008AFF;
        font-size: .18rem;
    }
  }
  &_btn{
    min-width: 1.6rem;
    max-width: 3rem;
    min-height: .28rem; 
    padding: .1rem;
    font-size: .18rem;
    color: #fff;
    text-align: center;
    background-color: #008AFF;
    border-radius: .4rem;
    margin: .48rem auto 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.form_inputbox{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
  position: relative;
  span{
    font-size: .18rem;
    // color: #888;
  }
  input{
    flex: 1;
    border:none !important;
  }
}
@media only screen and (max-width: 767px) {
  .login_title{
    padding: .38rem 0 .48rem;
    font-size: .4rem;
    &_sm{
      margin: 0.38rem 0 0.48rem;
      font-size: 0.4rem;
      margin-bottom: 0;
      text-align: center;
    }
  }
  

  .login_info {
    margin-bottom: .4rem;
    .login_input{
      border-color: #e4e4e4;
    }
    .form_item{
      margin-top:.32rem;
    }
  }
  .login_btn{
      min-width: 3.2rem;
      max-width: 5rem;

  }
  .login_btn,.login_info .form_item p,.login_info .login_input,.changetxt{
      font-size: .26rem !important;
  }
  .form_inputbox{
    border-color: #e4e4e4;
    span{
      font-size: .26rem;
    }
    input{
      flex: 1;
    }
  }
}

@media only screen and (max-width: 540px) {
  input::-ms-input-placeholder {
    font-size: .24rem;
  }
  input::-webkit-input-placeholder {
    font-size: .24rem;
  }
  .login_input {
    font-size: .24rem !important;
  }
  .getcode{
    font-size: .24rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/changephone.vue